import 'whatwg-fetch';

import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/fr'
import 'dayjs/locale/pt'

import utc from 'dayjs/plugin/utc'


class StockModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();

        this.getStock();
    }

    bindUI() {
        this.ui = {};

        this.ui.$stock = document.querySelectorAll('.js-stock');
        this.ui.$stockValue = document.querySelectorAll('.js-stock-value');
        this.ui.$stockVariation = document.querySelectorAll('.js-stock-variation');
        this.ui.$stockDate = document.querySelectorAll('.js-stock-date');
    }

    bindEvents() {

    }

    getStock() {
        fetch('https://api.lecho.be/services/stocks?quotes=urn:issue:560184184')
            .then((res) => {
                return res.json()
            })
            .then((json) => {
                if (json.results) {
                    this.computeValues(json.results[0]);
                } else {
                    this.hideResults();
                }
            });
    }

    computeValues(json) {
        // console.log(json.updatedOn);

        let stock = json,
            lastFull = json.lastPrice;

        stock.lastPrice = lastFull.toFixed(2);
        stock.dayChangePercentage = stock.dayChangePercentage.toFixed(2);

        let classToAdd = '',
            currentPercentage = stock.dayChangePercentage;

        if (stock.dayChangePercentage > 0) {
            stock.dayChangePercentage = `+${stock.dayChangePercentage}`
            classToAdd = 'is-up';
        } else {
            classToAdd = 'is-down';
        }

        stock.dayChangePercentage = stock.dayChangePercentage.replace('.', ',');
        stock.lastPrice = stock.lastPrice.replace('.', ',');

        dayjs.extend(utc)
        dayjs.locale(window.currentLocale);

        const currentDate = dayjs(stock.updatedOn);

        let dateToWrite = `${currentDate.utc().format('D MMMM - HH:mm:ss')}`;

        stock.updatedOn = dateToWrite;

        this.writeValues(stock, classToAdd);
    }

    writeValues(values, classToAdd) {
        [].forEach.call(this.ui.$stockValue, (item, index) => {
            item.classList.add(classToAdd);
            item.innerHTML = `${values.lastPrice}&euro;`;
        });

        [].forEach.call(this.ui.$stockVariation, (item, index) => {
            item.classList.add(classToAdd);

            if (item.classList.contains('is-tpl-finance')) {
                item.innerHTML = `(${values.dayChangePercentage}%)`;
            } else {
                item.innerHTML = `${values.dayChangePercentage}%`;
            }
        });

        [].forEach.call(this.ui.$stockDate, (item, index) => {
            item.innerHTML = `${values.updatedOn}`;
        });
    }

    hideResults() {
        [].forEach.call(this.ui.$stockValue, (item, index) => {
            item.classList.add('is-hidden');
        });

        [].forEach.call(this.ui.$stockVariation, (item, index) => {
            item.classList.add('is-hidden');
        });

        [].forEach.call(this.ui.$stockDate, (item, index) => {
            item.classList.add('is-hidden');
        });
    }
}

export default StockModule;
